import Vue from 'vue'

// Modified https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
export default {
  data () {
    return {
      isUpdatingApp: false,
      swRegistration: null,
      appUpdateExists: false
    }
  },

  created () {
    document.addEventListener('app-update-pending', this.appUpdateAvailable, { once: true })

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Prevent multiple refreshes
        if (this.isUpdatingApp) return
        this.isUpdatingApp = true

        Vue.reloadSiteTumbleQuery()
      })
    }
  },

  methods: {
    appUpdateAvailable (event) {
      if (event.detail) {
        // Cache for downstream
        this.swRegistration = event.detail.registration
      }

      if (this.swRegistration) {
        // Trigger UI to allow refresh
        this.appUpdateExists = true
      } else {
        Vue.logger.log('App update event', event)
        Vue.logger.error(new Error('SW update is no longer functioning as expected'))
      }
    },

    reloadUpdateApp () {
      this.appUpdateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (this.swRegistration && this.swRegistration.waiting) {
        // send message to SW to skip the waiting and activate the new SW
        this.swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' })
        this.swRegistration = undefined
      }
    }
  }
}
